import { Toast } from "react-bootstrap";
import { toastShowState } from "../../utils/atoms/atoms";
import { useRecoilState } from "recoil";
import { toastDetails } from "../../interfaces/app_types";

const ToastNotification = ({
  bg,
  message,
  delay = 2000,
  autohide = true,
}: toastDetails) => {
  // set toast state to false
  const [toastShow, setToastShow] = useRecoilState(toastShowState);
  return (
    <Toast
      onClose={() => setToastShow(false)}
      show={toastShow}
      delay={delay}
      autohide={autohide}
      bg={bg}
      className="toast-styles"
    >
      <Toast.Header>
        <strong className="me-auto">Notification</strong>
      </Toast.Header>
      <Toast.Body>{message}</Toast.Body>
    </Toast>
  );
};

export default ToastNotification;
